import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';

export const ImageContainer = styled('label')(() => ({
  cursor: 'pointer',
  '@media (max-width: 500px)': {
    margin: 'auto'
  }
}));

export const ImageInput = styled('input')(() => ({
  display: 'none'
}));

export const Button = styled(IconButton)(({ theme }) => ({
  alignSelf: 'flex-end',
  margin: theme.spacing(0.875, 0, 0.875, 1),
  flexGrow: 0
}));

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
}));
